interface RecordButtonProps {
  isRecording: boolean;
  isDisabled: boolean;
  onClick: () => void;
}

/**
 * Record button component for RecorderPanel.
 * Shows microphone icon when idle, square icon when recording.
 */
export function RecordButton({ isRecording, isDisabled, onClick }: RecordButtonProps) {
  return (
    <div className="relative my-3">
      <button
        className={`relative mx-auto flex h-[78px] w-[78px] items-center justify-center rounded-full transition-[background-color] duration-[200ms] active:scale-[0.97] active:translate-y-[3px] ${
          isRecording
            ? "recording-pulse-button"
            : `bg-gradient-to-br from-[#ffffff] via-[#f9f9ff] to-[#d6d6e6] idle-pulse-button hover:translate-y-[-1px] hover:brightness-105`
        }`}
        style={isRecording ? { backgroundColor: "#FF3258" } : undefined}
        onClick={onClick}
        disabled={isDisabled}
      >
        {/* Idle state: Microphone icon */}
        <svg
          className={`absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[35px] h-[35px] md:w-[39px] md:h-[39px] transition-opacity duration-[150ms] ${
            isRecording ? "opacity-0" : "opacity-100"
          }`}
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          {/* Taller microphone head */}
          <path
            d="M12 1C10.34 1 9 2.34 9 4V12C9 13.66 10.34 15 12 15C13.66 15 15 13.66 15 12V4C15 2.34 13.66 1 12 1Z"
            fill="var(--vocly-record-red, #ef4444)"
          />
          {/* Stand with complete base */}
          <path
            d="M19 10V12C19 15.87 15.87 19 12 19C8.13 19 5 15.87 5 12V10H7V12C7 14.76 9.24 17 12 17C14.76 17 17 14.76 17 12V10H19Z"
            fill="var(--vocly-record-red, #ef4444)"
          />
          {/* Complete horizontal base */}
          <rect
            x="8"
            y="19"
            width="8"
            height="2"
            rx="1"
            fill="var(--vocly-record-red, #ef4444)"
          />
        </svg>
        {/* Recording state: Black square icon */}
        <div
          className={`absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[22px] h-[22px] md:w-[25px] md:h-[25px] transition-opacity duration-[150ms] ${
            isRecording ? "opacity-100" : "opacity-0"
          }`}
          style={{
            backgroundColor: "var(--vocly-stop-black, #000000)"
          }}
        />
        <span className="sr-only">Toggle recording</span>
      </button>
    </div>
  );
}
